export type FaqItem = { q: string; a: string }

// Fonte única de verdade do FAQ — usada tanto pela seção interativa
// quanto pelo JSON-LD (FAQPage) para rich results no Google.
export const FAQ_ITEMS: FaqItem[] = [
  {
    q: "Preciso de cartão de crédito para testar?",
    a: "Não. O teste de 14 dias é liberado na hora, sem cartão e sem compromisso. Você só escolhe um plano se decidir continuar.",
  },
  {
    q: "Funciona para instrutor autônomo, não só para autoescola?",
    a: "Sim. O instrutor autônomo se cadastra como seu próprio ambiente e usa o mesmo conjunto de ferramentas de um CFC — agenda, alunos, cobranças e contratos no seu nome.",
  },
  {
    q: "O aluno paga as aulas pelo app?",
    a: "O aluno agenda aulas e solicita pacotes pelo app, e enxerga os valores. A cobrança em si é controlada pelo CFC ou instrutor dentro do painel — o pagamento é combinado entre vocês.",
  },
  {
    q: "Como o aluno encontra a minha escola?",
    a: "Pelo app Agenda CFC, o aluno busca por localização (com GPS ou por cidade/região) e se conecta ao CFC ou instrutor mais próximo. Quanto mais completo o seu cadastro, mais fácil ele te acha.",
  },
  {
    q: "Os dados da minha escola ficam separados de outras?",
    a: "Sim. Cada CFC ou instrutor tem seu ambiente isolado (um banco de dados por escola), então seus alunos, agenda e financeiro nunca se misturam com os de outra escola.",
  },
  {
    q: "Tem aplicativo para os instrutores?",
    a: "Tem. O app do instrutor mostra a agenda do dia e permite marcar presença, falta ou atraso com justificativa, além de dar feedback sobre o aluno.",
  },
]
